import LessonFormModal from "./LessonFormModal"

export function DuplicateLessonModal({ closeModal, lessonData }) {
	return <LessonFormModal mode="duplicate" closeModal={closeModal} lessonData={lessonData} />
}

export default DuplicateLessonModal
